import React from "react";

import { Center, chakra } from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { APIOption } from "@noli/core";

import { genBlock } from "@/utils/bem";
import { Editor_Words } from "@/utils/lang/editor";
import SchemaProperty from "@/components/Property/SchemaProperty";
import { observer } from "mobx-react-lite";
import classNames from "classnames";

interface HighResSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const block = genBlock("c-high-res-switch");

const IHighResSwitch: React.FC<HighResSwitchProps> = ({ value, onChange, className }) => {
  const lang = langStore.tgt;
  return (
    <Center className={classNames(block(), className)} mt="16px">
      <SchemaProperty
        identifier={`high-res`}
        w="100%"
        py="4px"
        pr="4px"
        color="#FFFFFF"
        lang={lang}
        apiKey={Editor_Words["txt2img-sd-high-res"]}
        apiOption={new APIOption("bool", value)}
        value={value}
        setValue={() => onChange}
        fontSize="14px"
      />
    </Center>
  );
};

export const HighResSwitch = chakra(observer(IHighResSwitch));
